var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('setup-tabs',{attrs:{"tabs":_vm.tabs}},[_c('setup-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }